export default {
	CAROUSEL_RUN: 'CarouselRun',
};
